export const getMaterials = (apiClient) => {
    return {
        async fetch(ids) {
            const res = await apiClient.request('/calculator/materials', { ids });
            return res;
        }
    };
};
export const getBaseMaterials = (apiClient) => {
    return {
        async fetch(ids) {
            const res = await apiClient.request('/calculator/client-materials', { ids });
            return res;
        }
    };
};
